import React, { useEffect, useState } from 'react'
import styles from '../ModulosEdosCuenta/edosCuenta.module.sass'
import { Header } from 'pages/Header'
import { HeaderMovilCS } from 'pages/Header/Content/pages/HeaderMovil'

import { MenuCredito } from 'components/menuCredito'
import { Error500 } from 'components/Error/Error500'
import { EmptyMonths, ListMonths, ResultPerMonth } from '../ModulosEdosCuenta'
import HeaderMobileCredito from 'components/Header/HeaderMobileCredito'


export function EstadoCuentaListMovil(props){
    const {
        errorCode,
        acountStatusData,
        respMovements,
        dataTransaction,
        setRango,
        date
    } = props

    const [perMonth, setPerMonth] = useState()
    const [index, setIndex] = useState()

    const resetMonth = () => {
        setPerMonth()
    }

    useEffect(()=>{},[perMonth])

    return(
        <>
            <HeaderMovilCS />
            <div className="modalCredito full">
                <div className="contentModal">
                    {perMonth
                        ?
                            <HeaderMobileCredito title="Estado de cuenta" type="backFullAction" action={resetMonth}  />
                        :
                            <HeaderMobileCredito title="Estados de cuenta" type="back" />
                    }
                    {errorCode >= 500
                        ? <Error500 />
                        : <div className={`${styles?.contentSection} ${styles?.movil}`}>
                            <div className={styles?.contListMonths}>
                                {perMonth
                                    ?
                                        <ResultPerMonth
                                            perMonth={perMonth}
                                            respMovements={respMovements}
                                            dataTransaction={dataTransaction}
                                            setRango={setRango}
                                            index={index}
                                        />
                                    :
                                        acountStatusData?.fechas?.length > 0
                                            ?
                                                <ListMonths
                                                    meses={acountStatusData?.fechas} 
                                                    setRango={setPerMonth}
                                                    setIndex={setIndex}
                                                />
                                            : <EmptyMonths date={date} />
                                }
                            </div>
                        </div>
                    }
                    </div>
            </div>
        </>
    )
}